import {
  HTTP_METHOD_GET,
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
  applyQueryString,
} from '@/common/api/api.service'
import { API_BASE_URL } from '@/common/constant'
import { normalizeBaseHome } from '@/common/normalize/normalize-base-home'
import { HOME_API_ERROR_RESPONSE } from '@/common/resources/home-api-error-response'

/**
 * @typedef {object} RecommendHomeDetailParams
 * @property {string} seriesId
 * @property {string} contentId
 */

/**
 * @typedef {object} RecommendHomeLiveParams
 * @property {string} channelId
 * @property {string} seriesId
 * @property {string} genreCode
 */

/**
 * 콘텐츠 상세 추천탭 홈 카탈로그 api
 * @param homeCode DN1(vod) | DN2(movie) | DY1(live)
 * @param {(RecommendHomeDetailParams | RecommendHomeLiveParams | {})} params
 * @returns {Promise<undefined|*>}
 */
export const getRecommendHomeData = async ({ homeCode = '', params = {} }) => {
  try {
    const response = await apiRequest(
      commonRequestInstanceToAxiosRequestInfo({
        url: applyQueryString(
          `${API_BASE_URL}/v1/home/detail/${homeCode}`,
          normalizeParams(params),
        ),
        method: HTTP_METHOD_GET,
        needCommonParams: true,
        needCredential: true,
      }),
    )

    response.data = normalizeBaseHome(response?.data?.data)

    return response
  } catch (e) {
    console.error(`Get Recommend Home Data Error ${e.message}`)

    return HOME_API_ERROR_RESPONSE
  }
}

export const normalizeParams = (params) => {
  if (params?.channelId) {
    return {
      channel_id: params.channelId,
      series_id: params?.seriesId ?? '',
      genre_code: params?.genreCode ?? '',
    }
  }
  return {
    series_id: params?.seriesId ?? '',
    content_id: params?.contentId ?? '',
  }
}
